export default "__VITE_ASSET__26f4de45__"